import { getSignedUrl } from 'legacy-src/shared/clients/apiClient';

/**
 * Convert bucket URL to signed URL
 * @param {string} url The original URL to be signed.
 * @param {string} bucket The S3 bucket corresponding to the URL.
 * @returns {url}
 */
async function getSignedResource(url, bucket, failIfKeyIsMissing) {
  const vhost = `${bucket}.s3.amazonaws.com`;
  const key = url.includes(vhost) ? url.split(vhost)[1] : url.split(bucket)[1];
  let signedURL = await getSignedUrl({ key, bucket }, failIfKeyIsMissing);
  const signature = signedURL.split(/:443/)[1];
  return signature;
}

/**
 * Get bucket from url within the list of unit buckets
 * @param {string} url
 * @returns {bucket|false}
 * */
export const getValidBucketUrl = (url) => {
  const baseS3Url = url.split('.s3')[0];
  if (baseS3Url) {
    // eg ["https", "unit-resources-apc-nonprod"]
    return baseS3Url.split('://')[1];
  }
};

export async function getSignedS3ResourceUrl(url) {
  let resourceUrl = decodeURIComponent(url.replace(/\+/g, ' '));
  const urlBucket = getValidBucketUrl(resourceUrl);
  if (urlBucket) {
    const signature = await getSignedResource(resourceUrl, urlBucket);
    const baseURL = `https://${urlBucket}.s3.amazonaws.com`;
    return `${baseURL}${signature}`;
  }
  throw new Error(`Not a valid ${url} resource url`);
}

export async function getSignedUnitResource(url, failIfKeyIsMissing) {
  let resourceUrl = decodeURIComponent(url.replace(/\+/g, ' '));
  const urlBucket = getValidBucketUrl(resourceUrl);
  if (urlBucket) {
    const signature = await getSignedResource(
      resourceUrl,
      urlBucket,
      failIfKeyIsMissing,
    );
    const baseURL = `https://${urlBucket}.s3.amazonaws.com`;
    return `${baseURL}${signature}`;
  }
  throw new Error('Not a Unit Resource');
}

export const extractS3ResourceDomainFromUrl = (url) => {
  let newUrl = url;
  if (newUrl.startsWith(S3_RESOURCES_BUCKET)) {
    const urlParts = newUrl.split(`${S3_RESOURCES_BUCKET}/`);
    [, newUrl] = urlParts;
  }
  return newUrl;
};

export const isS3Resource = (url = '') =>
  !!url &&
  ((url.startsWith(S3_RESOURCES_BUCKET) &&
    S3_RESOURCES_BUCKET.includes('s3.amazonaws.com')) ||
    (!url.includes('http://') && !url.includes('https://')));

export const getResourceAddress = (url, subject) =>
  `${FYM_FRONTEND_URL}/${subject}/resources/${extractS3ResourceDomainFromUrl(
    url,
  )}`;
